import { Immutable } from "immer";
import React from "react";

import { Flair } from "../components/Flair";

type IProps = Immutable<{
    choices: ReadonlyArray<{ style: string; label: string }>;
    /** Sealy-only: gallery-caption "ribbon" flair swatches
     * (settings.CAPTION_STYLE_CHOICES), rendered after the flair grid. */
    ribbonChoices?: ReadonlyArray<{ style: string; label: string }>;
}>;

/**
 * The styleguide Flair element: one swatch per configured flair style
 * (settings.FLAIR_STYLE_CHOICES), each rendering the shared Flair component
 * with a fixed sample content string.
 */
export const StyleguideFlairSwatches = (props: IProps): React.JSX.Element => (
    <>
        <br />
        <div
            id="element-tester"
            className="l-capped-width styleguide--swatches"
        >
            {props.choices.map((choice) => (
                <div key={choice.style} className="styleguide--flair-swatch">
                    {/* The swatch box border targets the direct child div
                        (.styleguide--flair-swatch > div), so the flair needs a
                        neutral wrapper. */}
                    <div>
                        <Flair
                            flair={{
                                style: choice.style,
                                content: "Flair Example",
                            }}
                        />
                    </div>
                    <code>{choice.label}</code>
                </div>
            ))}
            {props.ribbonChoices && props.ribbonChoices.length > 0 && (
                <>
                    <br />
                    {props.ribbonChoices.map((ribbon) => (
                        <div
                            key={ribbon.style}
                            className="styleguide--flair-swatch"
                        >
                            <div>
                                <div
                                    className={`gallery-caption ${ribbon.style}`}
                                >
                                    Ribbon Flair Example
                                </div>
                            </div>
                            <code>{ribbon.label}</code>
                        </div>
                    ))}
                </>
            )}
        </div>
    </>
);
